import api from './axios';

export const login = (credentials) =>
    api.post('/auth/login/', credentials);

export const register = (data) =>
    api.post('/auth/register/', data);

export const getProfile = () =>
    api.get('/auth/profile/');

export const updateProfile = (data) =>
    api.patch('/auth/profile/', data);

export const changePassword = (data) =>
    api.post('/auth/change-password/', data);